<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ 'learning_paths.add_task' | translate }}</span>
      <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content>
    <div class="task-groups">
      @if (loading) {
        <div role="status">{{ 'main.loading' | translate }}</div>
      }
      @if (loadFailed) {
        <div role="alert">{{ 'tasks.load_error' | translate }}</div>
      }
      @for (group of taskGroups; track group.id) {
        <div class="task-group">
          <mat-checkbox class="task-group-title"
                        [checked]="group.selectedTasks.length === group.tasks.length"
                        [indeterminate]="group.selectedTasks.length > 0 && group.selectedTasks.length < group.tasks.length"
                        [disabled]="isGroupDisabled(group)"
                        (change)="selectGroupTasks(group, $event.checked ? group.tasks : [])">
            {{ group.title }}
          </mat-checkbox>
          <mat-selection-list [ngModel]="group.selectedTasks"
                              (ngModelChange)="selectGroupTasks(group, $event)" [attr.aria-label]="group.title">
            @for (task of group.tasks; track task.id) {
              <mat-list-option [value]="task" [disabled]="assignedTaskIds.has(task.id)">{{ task.title }}</mat-list-option>
            }
          </mat-selection-list>
        </div>
      }
      @if (!loading && !loadFailed && !taskGroups.length) {
        <div class="no-data">{{ 'no_data' | translate }}</div>
      }
    </div>
  </div>
  <div class="button-wrapper">
    <button mat-raised-button [disabled]="loading || loadFailed" (click)="save()">
      {{ 'main.save' | translate }}
    </button>
  </div>
</div>
